import React from 'react'
import './techSkills.css'

function TechSkills() {
    return (
        <div>
            <div className='techcontainer'>
            <div className='flip-card-tech'>
                <div className='flip-card-inner-tech'>
                    <div className='flip-card-front-tech'>
                        <h1>
                        <br/>
                            IoT- Internet of Things
                        </h1>
                    </div>
                    <div class="flip-card-back-technontech">
                        <h3>
                        <br/>
                        <br/>
                         <a href='https://youtu.be/h0gWfVCSGQQ'>Video Resource</a>
                         <br/>
                         <br/>
                         <a href='https://www.udemy.com/share/101WnO/'>Certified Course</a>
                        </h3>
                    </div>
                </div>
            </div>
            <div className='flip-card-tech'>
                <div className='flip-card-inner-tech'>
                    <div className='flip-card-front-tech'>
                        <h1>
                        <br/>
                            Machine Learning
                        </h1>
                    </div>
                    <div class="flip-card-back-technontech">
                        <h3>
                        <br/>
                        <br/>
                        <a href='https://youtube.com/playlist?list=PLLssT5z_DsK-h9vYZkQkYNWcItqhlRJLN'>Video Resource</a>
                        <br/>
                        <br/>
                        <a href='https://www.edureka.co/executive-programs/machine-learning-and-ai?utm_source=search&utm_medium=google&utm_campaign=PGDINML-Search-ML&utm_term=ML-Course&utm_content=rsa&gclid=CjwKCAjwpKCDBhBPEiwAFgBzj00XullUylwD4LVakNw_fC_PxOsrs-RWkgqMFPQvDUWRRi_EUBa__hoC4qAQAvD_BwE'>
                            Certified Course
                        </a>
                        </h3>
                    </div>
                </div>
            </div>
            <div className='flip-card-technontech'>
                <div className='flip-card-inner-technontech'>
                    <div className='flip-card-front-technontech'>
                        <h1>
                        <br/>
                            Full Stack Development
                        </h1>
                    </div>
                    <div class="flip-card-back-technontech">
                        <h3>
                        <br/>
                        <br/>
                        <a href='https://youtube.com/playlist?list=PLC3y8-rFHvwgg3vaYJgHGnModB54rxOk3'>Video Resource</a>
                        <br/>
                        <br/>
                        <a href='https://www.udemy.com/course/the-complete-web-developer-course-2/?gclid=CjwKCAjwpKCDBhBPEiwAFgBzjyXFZ2czZF4k6FGos5RJ815hXRVtrrGnns71mPPZLsLADHZj3ToEbBoCk5UQAvD_BwE&matchtype=e&utm_campaign=WebDevelopment_v.PROF_la.EN_cc.INDIA_ti.8322&utm_content=deal4584&utm_medium=udemyads&utm_source=adwords&utm_term=_._ag_82381205698_._ad_392371003106_._kw_web+development+courses_._de_c_._dm__._pl__._ti_kwd-12372542_._li_9062235_._pd__._'>
                            Certified Course
                        </a>
                        </h3>
                    </div>
                </div>
            </div>
            <div className='flip-card-technontech'>
                <div className='flip-card-inner-technontech'>
                    <div className='flip-card-front-technontech'>
                        <h1>
                        <br/>
                            Application Development
                        </h1>
                    </div>
                    <div class="flip-card-back-technontech">
                        <h3>
                        <br/>
                        <br/>
                        <a href='https://youtube.com/playlist?list=PL4cUxeGkcC9jLYyp2Aoh6hcWuxFDX6PBJ'>Video Resource</a>
                        <br/>
                        <br/>
                        <a href='https://www.coursera.org/courses?query=mobile%20app%20development&page=1'>
                            Certified Course
                        </a>
                        </h3>
                    </div>
                </div>
            </div>
        </div>
        </div>
    )
}

export default TechSkills
